
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TargetMasterGrid extends Serenity.EntityGrid<TargetMasterRow, any> {
        protected getColumnsKey() { return 'OMS.TargetMaster'; }
        protected getDialogType() { return TargetMasterDialog; }
        protected getIdProperty() { return TargetMasterRow.idProperty; }
        protected getLocalTextPrefix() { return TargetMasterRow.localTextPrefix; }
        protected getService() { return TargetMasterService.baseUrl; }
        protected getInsertPermission() { return CustomerRow.insertPermission; }
        protected getUpdatePermission() { return CustomerRow.updatePermission; }


        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}